/* Pure Desi — Round 7 UX companion (2026-07-24).
   Recently-viewed strip: records product visits in localStorage and
   populates the pd-recently-viewed section (hidden until 2+ products).
   No personal data, device-local only. */
(function () {
  'use strict';
  var KEY = 'pd_recent';
  var read = function () {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  };
  var write = function (v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
  };

  var match = location.pathname.match(/\/products\/([a-z0-9-]+)/i);
  var current = match ? match[1].toLowerCase() : null;
  if (current) {
    var list = read().filter(function (h) { return h !== current; });
    list.unshift(current);
    write(list.slice(0, 8));
  }


  /* [R20] PDP per-box delivery maths. Delivery is charged once per ORDER,
     not per item, so a second box ships for no extra delivery fee — until
     the order crosses the freight band. Abhi 2026-07-26: THE BAND IS
     WEIGHT, NOT VALUE — over 4kg the rate moves to the next stage (bands re-read 2026-09-11). (An
     earlier build gated on line total >= $200; that was wrong.)
     Weight comes from Shopify's own product JSON (variants[].weight, in
     grams) plus the CURRENT cart weight from /cart.js, so the check
     accounts for what the shopper already has in the basket, not just
     this line. If either lookup fails we render NOTHING — we never state
     a flat-fee claim we could not verify. Note that both endpoints return
     HTML under ?preview_theme_id (same gotcha as the recently-viewed
     strip), so this line only appears on the real live URL. */
  /* Express rate card as configured in Shopify Shipping (read 2026-09-11),
     by cart TOTAL weight:
       0-4kg $25 | 4.1-10kg $50 | 10.1-20kg $110 | 20.1kg+ $150 | pickup free
     Since 2026-09-11 every variant weight is the GROSS parcel weight
     (Large 1.2kg, Small 0.65kg, Extra Small 0.35kg, slabs 0.5kg, halwa
     0.6kg, XL 2.0kg), so /cart.js total_weight is exactly what Shopify
     rates on and no packaging allowance is added any more. PD_PACK_G is
     kept at 0 so the ladder can be re-derived if that ever changes.
     The customer-facing copy never names a band range — it states their
     actual weight and the next price. */
  var PD_PACK_G = 0;
  var PD_TIERS = [
    { cardMax: 4000,     price: 25 },
    { cardMax: 10000,    price: 50 },
    { cardMax: 20000,    price: 110 },
    { cardMax: Infinity, price: 150 }
  ].map(function (t) {
    t.max = (t.cardMax === Infinity) ? Infinity : t.cardMax - PD_PACK_G;
    return t;
  });
  var pdTier = function (g) {
    for (var i = 0; i < PD_TIERS.length; i++) { if (g <= PD_TIERS[i].max) return PD_TIERS[i]; }
    return PD_TIERS[PD_TIERS.length - 1];
  };
  var pdNextTier = function (t) {
    var i = PD_TIERS.indexOf(t);
    return (i > -1 && i < PD_TIERS.length - 1) ? PD_TIERS[i + 1] : null;
  };
  /* Is the shopper on the Store Pickup tab? Bird writes its own cart
     attribute "Delivery Method" = "Pick Up" (also mirrored into a hidden
     form input), so we read THAT rather than Bird's CSS classes — the app
     is frozen and its markup is not ours to depend on. The DOM input is
     read first because it flips the instant the tab is clicked; the
     /cart.js copy is the fallback. */
  var pdPickupSelected = function (c) {
    var el = document.querySelector('input[name="attributes[Delivery Method]"]');
    var v = el ? el.value : ((c && c.attributes) ? c.attributes['Delivery Method'] : '');
    return /pick\s*up/i.test(String(v || ''));
  };
  /* [LP-1] 29 Sep 2026 luxe prices: whole dollars without ".00" */
  var pdMoney = function (n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : String(Math.round(n))); };
  /* [QA 4 Oct 2026] same rounding and spacing as pd-qw.js kg(): 350 g printed 0.3kg here and 0.4 kg in the "$25 covers up to 4 kg" row */
  var pdKg = function (g) { return (Math.round(g / 100) / 10).toFixed(1) + ' kg'; };
  var pdDeliveryMaths = function () {
    if (document.body.className.indexOf('template-product') === -1) return;
    var input = document.querySelector('input[name="quantity"]');
    if (!input) return;
    /* Insert AFTER the whole .flex-buttons row, NEVER inside it. That row is
       display:flex + flex-wrap and holds BOTH the quantity selector and the
       Add-to-cart button, so a block-level child becomes a flex item and
       wraps the ATC onto a new line. Measured cost of getting this wrong:
       +100px on mobile ATC (1052 -> 1152, undoing R11/R12) and the note
       itself squeezed to 3 lines in the narrow column. Placed just below
       the row it costs 0px of ATC position. */
    var anchor = input.closest('.flex-buttons') || input.closest('quantity-selector')
              || input.closest('.quantity-selector') || input.parentNode;
    if (!anchor || !anchor.parentNode) return;
    if (anchor.parentNode.querySelector('[data-pd-deliv]')) return;
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    if (!handle) return;

    var note = document.createElement('p');
    note.className = 'pd-deliv-math';
    note.setAttribute('data-pd-deliv', '');
    anchor.parentNode.insertBefore(note, anchor.nextSibling);

    var weights = null, cartG = null;
    var jget = function (url) {
      return fetch(url, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    };
    var variantGrams = function () {
      if (!weights) return null;
      var id = null;
      try { id = new URLSearchParams(location.search).get('variant'); } catch (e) {}
      if (id && weights.byId[id] != null) return weights.byId[id];
      return weights.first;
    };
    var render = function () {
      var q = parseInt(input.value, 10);
      if (!q || q < 1) q = 1;
      var g = variantGrams();
      if (g == null || cartG == null) { note.textContent = ''; return; }
      var used = cartG + g * q;
      var t = pdTier(used);
      /* how many MORE of this product fit before the rate steps up */
      var left = (t.max === Infinity || g <= 0) ? 0 : Math.floor((t.max - used) / g);
      var more = left === 1 ? '1 more box' : left + ' more boxes';
      if (q === 1) {
        note.innerHTML = left >= 1
          ? 'Add up to ' + more + ' — <strong>delivery stays ' + pdMoney(t.price) + '</strong>'
            /* 28 Sep 2026 (critique fix #2): the per-box maths from the first box, not only once the quantity is 2 */
            + ' · two boxes work out at ' + pdMoney(t.price / 2) + ' delivery each'
          : '<strong>Delivery ' + pdMoney(t.price) + '</strong> for this order';
      } else {
        note.innerHTML = 'Delivery works out at <strong>' + pdMoney(t.price / q) +
                         ' per box</strong>' + (left >= 1
                           ? ' — room for ' + more + ' at the same fee'
                           : ' — one fee covers the whole order');
      }
    };
    var loadCart = function () {
      return jget('/cart.js').then(function (c) {
        cartG = (c && typeof c.total_weight === 'number') ? c.total_weight : null;
      });
    };
    Promise.all([
      jget('/products/' + handle + '.js').then(function (pr) {
        if (!pr || !pr.variants || !pr.variants.length) return;
        weights = { byId: {}, first: null };
        pr.variants.forEach(function (v, i) {
          var g = (typeof v.weight === 'number') ? v.weight
                : (typeof v.grams === 'number' ? v.grams : null);
          weights.byId[v.id] = g;
          if (i === 0) weights.first = g;
        });
      }),
      loadCart()
    ]).then(render);

    input.addEventListener('input', render);
    input.addEventListener('change', render);
    /* theme +/- buttons mutate .value directly without firing events */
    anchor.addEventListener('click', function () { setTimeout(render, 30); });
    /* the cart can change without a reload (drawer adds) and it only ever
       gets HEAVIER, so a stale reading would over-claim — re-read it.
       The theme's add-to-cart event does not bubble: capture phase. */
    document.addEventListener('add-to-cart', function () {
      loadCart().then(render);
    }, true);
  };

  /* [R21] CART PAGE delivery/headroom line. Shows the shopper, BEFORE they
     reach checkout, what their order weighs, that delivery is one flat fee
     inside the band, and how much more they can add without paying more.
     WEIGHT SOURCE: /cart.js total_weight = the sum of Shopify VARIANT
     weights, which is exactly what the carrier rate is computed from. Do
     NOT use the custom.net_weight metafield here — that is the food weight
     only and excludes packaging, so it would understate and over-promise.
     Cart page only, by design: cart_drawer_actions is "show-view", so the
     drawer has no checkout button and every shopper passes through /cart.
     "from $25" (not "$25") because the site quotes delivery that way and
     the exact figure is confirmed at checkout — Rule 3.
     The theme re-renders #AjaxCartSubtotal on every quantity change, which
     wipes injected nodes, so we re-paint on mutation. The observer would
     loop on our own writes, hence the innerHTML equality guard. */
  /* [CF2 2026-09-25, Abhi: "price at the delivery choice"] The Bird block's own wrapper on /cart
     (step 2, "Pick up or delivery, and your date"). Our node goes in as the wrapper's first child,
     never inside Bird's markup. */
  var pdStep2Host = function () {
    var ws = document.querySelectorAll('.cart-section > main > div.margin-bottom--regular');
    for (var i = 0; i < ws.length; i++) {
      if (ws[i].querySelector('.shopify-app-block, #birdchime-slots-box')) return ws[i];
    }
    return null;
  };
  var pdCartDelivery = function () {
    if (document.body.className.indexOf('template-cart') === -1) return;
    var timer = null;
    var paint = function () {
      var host = document.querySelector('.pd-delivery-info');
      if (!host) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (c) {
          var el = host.querySelector('[data-pd-cartdeliv]');
          var s2 = pdStep2Host(), d2 = s2 ? s2.querySelector(':scope > [data-pd-deliv2]') : null;
          if (!c || typeof c.total_weight !== 'number' || !c.item_count) {
            if (el) el.remove();
            if (d2) d2.remove();
            document.body.classList.remove('pd-deliv2-on');
            return;
          }
          if (!el) {
            el = document.createElement('span');
            el.setAttribute('data-pd-cartdeliv', '');
            el.className = 'pd-cart-deliv';
            host.insertBefore(el, host.firstChild);
          }
          var g = c.total_weight, t = pdTier(g), nxt = pdNextTier(t), html;
          html = '<strong>Delivery ' + pdMoney(t.price) + '</strong> — this order is ' + pdKg(g) + '.';
          /* 28 Sep 2026 (critique fix #1): the next band is named only once the bag is within 1 kg of it;
             "goes to $50" on a 0.7 kg bag read as a price, not a limit */
          if (nxt && t.max - g < 1000) {
            var room = t.max - g;
            html += room >= 100
              ? ' Add ' + pdKg(room) + ' more before delivery goes to ' + pdMoney(nxt.price) + '.'
              : ' Any more and delivery moves to ' + pdMoney(nxt.price) + '.';
          }
          if (el.innerHTML !== html) el.innerHTML = html;
          /* pickup is free — dim the delivery figure so it reads as
             "not what you'll pay" rather than a competing price */
          var muted = pdPickupSelected(c);
          if (el.classList.contains('pd-cart-deliv--muted') !== muted) {
            el.classList.toggle('pd-cart-deliv--muted', muted);
          }
          /* [CF2] the same figure where the shopper chooses delivery or pickup, plus the event
             advice (Abhi, 25 Sep: customers ordering for an event must plan for courier delays).
             On pickup it dims and the delivery-only lines hide. Once it paints, pd-qw.css hides
             the step-3 copy (body.pd-deliv2-on) so the page says it once. */
          if (s2) {
            if (!d2) {
              d2 = document.createElement('div');
              d2.setAttribute('data-pd-deliv2', '');
              d2.className = 'pd-deliv2';
              s2.insertBefore(d2, s2.firstChild);
            }
            var h2 = '<p class="pd-deliv2__price"><strong>Delivery ' + pdMoney(t.price) + '</strong> for this order (' + pdKg(g) + '). Pickup from our stores is free.</p>';
            if (nxt && t.max - g < 1000) {
              var room2 = t.max - g;
              h2 += '<p class="pd-deliv2__room">' + (room2 >= 100
                ? 'Add ' + pdKg(room2) + ' more before delivery goes to ' + pdMoney(nxt.price) + '.'
                : 'Any more and delivery moves to ' + pdMoney(nxt.price) + '.') + '</p>';
            }
            /* 28 Sep 2026 (critique fix #1): the event advice is said once, by Bird's own delivery notes
               ("For special events, we recommend selecting delivery 2–3 days earlier…"), right under the date picker */
            /* [PR-1] Diwali delivery promise (go-live ~12 Oct 2026): delivery tab, Diwali or mixed bag only. Bird's own notes
               already give the event advice, so this line only adds what the promise does and doesn't cover. */
            if (!muted && /diwali|mix/.test(document.body.getAttribute('data-pd-mode') || '')) {
              h2 += '<p class="pd-deliv2__promise" style="margin:.35rem 0 0;font-size:13px;line-height:1.45;color:#4A4360">Our delivery promise covers Diwali parcels that arrive damaged, not fresh, or more than two business days late. It doesn\'t cover a missed occasion. <a href="/promise" style="color:#5B0202;font-weight:600;text-decoration:underline;text-underline-offset:3px">How it works</a></p>';
            }
            if (d2.innerHTML !== h2) d2.innerHTML = h2;
            if (d2.classList.contains('pd-deliv2--pickup') !== muted) d2.classList.toggle('pd-deliv2--pickup', muted);
            document.body.classList.add('pd-deliv2-on');
          }
        });
    };
    var schedule = function () { clearTimeout(timer); timer = setTimeout(paint, 250); };
    schedule();
    var root = document.getElementById('cart') || document.querySelector('.cart-form');
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    /* the Bird fulfilment tabs can sit outside #cart, so the observer above
       will not see a Shipping <-> Store Pickup switch. Repaint on clicks
       inside the Bird widget only (capture phase; scoped so we are not
       re-fetching /cart.js on every click on the page). */
    /* [CF2 25 Sep] Bird's markup now uses "bird-..." classes (bird-method-tab etc.), so the old
       "bcdp" match never fired and the pickup/delivery state went stale. Both are matched now.
       Bird writes "Delivery Method" to the cart a moment after the tap, so paint again later. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[class*="bcdp"], [class*="bird-"]')) { schedule(); setTimeout(schedule, 1200); }
    }, true);
  };

  var mount = function () {
    var holder = document.querySelector('[data-pd-recent]');
    if (!holder) return;
    var grid = holder.querySelector('[data-pd-recent-grid]');
    if (!grid) return;
    var handles = read().filter(function (h) { return h !== current; }).slice(0, 4);
    if (handles.length < 2) return;
    /* [QA 4 Oct 2026] the strip used to appear only after four product fetches, pushing the newsletter and footer down under
       a shopper who had already scrolled there (layout shift 0.4 to 0.6 on desktop). Placeholder cards hold its place now. */
    grid.innerHTML = handles.map(function () { return '<span class="pd-recent__card pd-recent__card--ph" aria-hidden="true"><span class="pd-recent__media"></span><span class="pd-recent__name">&nbsp;</span><span class="pd-recent__price">&nbsp;</span></span>'; }).join('');
    holder.hidden = false;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };
      var cards = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=420' : '';
        var price = '<span class="pd-cur">$</span>' + (p.price % 100 ? (p.price / 100).toFixed(2) : String(p.price / 100));   /* [LP-1] */
        return '<a class="pd-recent__card" href="' + esc(p.url) + '">' +
          (img ? '<span class="pd-recent__media"><img src="' + esc(img) + '" alt="" loading="lazy"></span>' : '') +
          '<span class="pd-recent__name">' + esc(p.title) + '</span>' +
          '<span class="pd-recent__price">' + price + '</span></a>';
      });
      if (cards.length >= 2) {
        grid.innerHTML = cards.join('');
        holder.hidden = false;
      } else {
        grid.innerHTML = '';
        holder.hidden = true;
      }
    });
  };

  /* Delivery/order instructions: auto-save [data-pd-attr] textareas to cart
     attributes (mirrors the theme's cart-note behaviour). Delegated so it
     works inside the re-rendered cart drawer too. */
  var attrTimer = null;
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.getAttribute || el.getAttribute('data-pd-attr') === null) return;
    clearTimeout(attrTimer);
    attrTimer = setTimeout(function () {
      var attrs = {};
      attrs[el.getAttribute('data-pd-attr')] = el.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () { /* non-critical */ });
    }, 400);
  });

  /* [R8, amended R12] The What's Inside panel renders as <details open>
     under the product title; collapse it on mobile AND on short desktop
     viewports (laptops <=880px tall, e.g. 1366x768) so add-to-cart stays
     above the fold. If this never runs (JS blocked) the panel stays
     open — nothing is ever hidden. */
  var collapseWhatsInside = function () {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px), (max-height: 880px)').matches) return;
    var panels = document.querySelectorAll('details.pd-wi-inline[open]');
    for (var i = 0; i < panels.length; i++) panels[i].removeAttribute('open');
  };


  /* [R14] Store pages: render each store's live in-store menu band
     (pure-desi-menu.pages.dev) after the location/map section — a clear
     LINK band (per Abhi 2026-07-25, replacing the embedded iframe).
     JS-rendered on purpose - keeps the giant store-page templates
     untouched. */
  var STORE_MENUS = {
    '/pages/arndell-park': ['Arndell Park', 'arndell'],
    '/pages/kellyville': ['Kellyville', 'kellyville'],
    '/pages/melbourne': ['Campbellfield', 'melbourne'],
    '/pages/brisbane': ['Woodridge', 'brisbane']
  };
  var mountStoreMenu = function () {
    var meta = STORE_MENUS[location.pathname.replace(/\/+$/, '')];
    if (!meta || document.querySelector('.pd-storemenu')) return;
    var host = document.querySelector('.main-location');
    var anchor = host ? host.closest('[id^="shopify-section"]') : null;
    if (!anchor) return;
    var url = 'https://pure-desi-menu.pages.dev/?store=' + meta[1];
    var sec = document.createElement('section');
    sec.className = 'pd-storemenu';
    sec.setAttribute('aria-label', 'Pure Desi ' + meta[0] + ' in-store menu');
    sec.innerHTML =
      '<p class="pd-storemenu__script" aria-hidden="true">Fresh from the counter,</p>' +
      '<h2 class="pd-storemenu__t">The ' + meta[0] + ' menu</h2>' +
      '<p class="pd-storemenu__p">The full in-store range of sweets, savouries and hot food.</p>' +
      '<a class="pd-btn pd-btn--cherry pd-storemenu__cta" href="' + url + '" target="_blank" rel="noopener">View the ' + meta[0] + ' menu <span class="ar" aria-hidden="true">→</span></a>';
    anchor.insertAdjacentElement('afterend', sec);
  };

  var ready = function () {
    collapseWhatsInside();
    mount();
    pdDeliveryMaths();
    pdCartDelivery();
    mountStoreMenu();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
